import firebase from "../firebase";

export default function({ officeId, userId, roomId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "messagingUser",
        funcName: "unpageRoomFromUser",
        data: { officeId, userId, roomId }
    });
}
